import VrWorld from "./VrWorld.container";

export default VrWorld;
